const sign_content = document.querySelector('.sign-content'),
    sign_content_types = JSON.parse(sign_content.getAttribute('data-types')),
    sign_content_text = sign_content.querySelectorAll('[data-text-'+sign_content_types[0]+']'),
    sign_content_title = sign_content.querySelectorAll('[data-title-'+sign_content_types[0]+']'),
    sign_content_href = sign_content.querySelectorAll('[data-href-'+sign_content_types[0]+']'),
    sign_content_form = sign_content.querySelectorAll('form[data-fields-'+sign_content_types[0]+']');
var sign_content_classes = {};
sign_content_types.forEach(type=>{
    sign_content_classes[type] = sign_content.querySelectorAll('.only-page-'+type);
});
window.addEventListener('load',()=>{
    sign_content_text.forEach(el=>{
        el.style.minHeight = el.getBoundingClientRect().height + 'px';
    });
})
document.querySelectorAll('.btn-sign-change').forEach(btn=>{
    btn.addEventListener('click',(evt)=>{
        evt.preventDefault();
        change(btn.getAttribute('href'),true);
    });
});

function removeLanguageFromPath(path) {
    // Регулярное выражение для поиска языкового кода в начале строки
    const langPattern = /^\/[a-z]{2}\//;

    // Проверяем, соответствует ли начало строки шаблону языкового кода
    if (langPattern.test(path)) {
        // Удаляем языковой код, возвращая измененную строку
        return path.replace(langPattern, '/');
    }

    // Если языковой код не найден, возвращаем исходную строку
    return path;
}

function change(href, push) {
    const type_href = removeLanguageFromPath(href);
    const type = type_href==='/signin/lost/' ? 'lost' : type_href.substring(1,type_href.length - 1);
    if(sign_content.querySelectorAll('[data-text-'+type+']').length===0) {
        return false;
    }
    if(push) {
        window.history.pushState({}, "", href);
    }
    document.title = sign_content.getAttribute('data-'+type);
    sign_content_text.forEach(el=>{
        printText(el,el.getAttribute('data-text-'+type));
    });
    sign_content_href.forEach(el=>{
        el.setAttribute('href',el.getAttribute('data-href-'+type));
    });
    sign_content_title.forEach(el=>{
        el.setAttribute('title',el.getAttribute('data-title-'+type));
    });
    Object.entries(sign_content_classes).forEach(([classes_type,classes])=>{
        if(classes_type===type) {
            classes.forEach(el=>{
                el.classList.add('show');
            });
        } else {
            classes.forEach(el=>{
                el.classList.remove('show');
            });
        }
    });
    sign_content_form.forEach(el=>{
        let field_names = JSON.parse(el.getAttribute('data-fields-'+type));
        el.querySelectorAll('.field').forEach(container=>{
            let field = container.querySelector('input');
            if(field!==null && field_names.includes(field.getAttribute('name'))) {
                if(typeof field.customErrors !== 'undefined') {
                    field.customErrors = {};
                    field.setCustomValidity('');
                    field.reportValidity();
                    field.focus();
                    field.blur();
                    field.reportValidity();
                }
                if(!container.classList.contains('show')) {
                    container.classList.add('show');
                    field.removeAttribute('disabled');
                }
            } else {
                container.classList.remove('show');
                if(field!==null) {
                    field.setAttribute('disabled', 'disabled');
                }
            }
        });
    });
    return true;
}

window.addEventListener('popstate', ()=> {
    change(window.location.pathname,false);
});